<template>
  <div id="Opportunities_CommunityInvolvement">
    <usc-hero :title="this.hero.title" :loResSrc="this.hero.loResSrc" :hiResSrc="this.hero.hiResSrc" :color="this.page.color"></usc-hero>
    <usc-intro :copy="this.intro"></usc-intro>
    <div class="body mb gutter-lg">
      <p><i>Marshall is a leader within the overall Trojan cohort, with many student-led programs that give back to the community, such as Los Angeles Community Impact, an undergraduate student-led consulting group that places teams of students in the community to assist local nonprofits and small businesses. </i></p>
      <p>Undergraduates also have organized Marshall Community Service Day, which connects Marshall students, faculty and staff with volunteer sites around Los Angeles for a day of public service supporting a variety of nonprofit organizations, including Union Rescue Mission, Heal the Bay and area schools.</p>
    </div>
    <usc-videoEmbed :frameTitle="this.video.frameTitle" :caption="this.video.caption" :videoSource="this.video.src"></usc-videoEmbed>
    <div class="body gutter-lg mb">
      <p><strong>Joint Educational Project (JEP)</strong><br />Founded in 1972, JEP is one of the oldest and largest service-learning programs in the country, offering the unique opportunity to combine academic coursework with outreach in the neighborhood surrounding the University Park Campus. Each year, approximately 2,000 students receive academic credit for their participation in JEP. In addition, 400 students serve as noncredit volunteers, sharing their time and special talents.</p>
      <div class="youtube-embed">
        <a href="https://www.youtube.com/watch?v=CVRFZZAHdfk" 
          target="_blank" 
          rel="noopener" 
          aria-label="Watch JEP: 50 Years of Service Learning on YouTube (opens in a new tab)">
          
          <img src="../../assets/community-and-service-learning-thumbnail.jpg" 
                alt="" 
                role="presentation">
        </a>
      </div>
    </div>
    <div class="body gutter-lg mb">
      <p><strong>Volunteer Center</strong><br />The <a href="https://campusactivities.usc.edu/programs/volunteer/" target="_blank" class="inline-hyperlink">USC Volunteer Center</a> is a primarily student-run program within the Division of Student Affairs that offers opportunities for students, alumni, faculty and staff to get involved with the community. Each year, the Volunteer Center identifies and organizes numerous service projects and maintains an extensive database of more than 200 nonprofits and other agencies that offer volunteer opportunities.</p>
      <p>Programs within the Volunteer Center include Friends & Neighbors Day, SERVE L.A., Trojans Serve and Alternative Breaks.</p>
      <p><i>Alternative Breaks</i><br />In March 1991, USC students and staff launched Alternative Breaks to engage in service learning and volunteerism in communities outside of Los Angeles. These service-learning trips help participants make tangible connections between what they learn in the classroom and what they will encounter once they have jobs and experiences outside the university. Geared to students’ interests, each project includes an introduction to the social, cultural and historical context of the specific community students will experience throughout the week. Opportunities for discussion and reflection help students gain new perspectives on social problems. Student participants pay a nominal fee to cover transportation, housing and meals for the week.</p>
      <p><i>Friends & Neighbors Service Day</i><br />The Volunteer Center’s Friends & Neighbors Service Day program is one of the most popular USC volunteer events of the year. The initiative takes place on Saturdays throughout the school year and provides a great opportunity to meet fellow students as well as to get involved in the local community.</p>
    </div>

  </div>
</template>

<script>
import hero from '@/components/Hero'
import intro from '@/components/Intro'
import videoEmbed from '@/components/videoEmbed'
import Cta from '@/components/Cta'

export default {
  name: 'CommunityInvolvement',
  components: {
    'usc-hero': hero,
    'usc-intro': intro,
    'usc-videoEmbed': videoEmbed,
    'usc-cta': Cta
  },
  data () {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Community Engagement',
        loResSrc: '../../../static/HeroImages/Marshall113.png',
        hiResSrc: '../../../static/HeroImages/Marshall113.png'
      },
      intro: [
        'More than 60 percent of USC students volunteer as part of the university’s community outreach programs, providing educational, social and wellness services that strengthen surrounding neighborhoods and communities worldwide while offering rewarding personal experiences.'
      ],
      video: {
        caption: 'The Other 152 Hours',
        src: 'https://player.vimeo.com/video/393483866',
        frameTitle: 'The Other 152 Hours'
      }
    }
  },
  created () {
    this.$root.setPageHeader('Opportunities', 'Community Engagement')
  }
}
</script>

<style scoped lang="scss">
.youtube-embed {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
}
.youtube-embed img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/life-at-marshall/CommunityInvolvement.vue